import { useFetch } from '../../../hooks/use-fetch';
import { Notification } from '../../../models/notification';
import { errorNotification } from '../../../providers/mantine-notifications';
import {
  UseGetNotificationsProps,
  UseReadAllNotificationsProps,
  UseSetNotificationsReadedProps,
} from '../../../utils/types/data/hooks/notifications';
import {
  getNotificationsRequest,
  readAllNotificationsRequest,
  readNotificationsRequest,
} from '../../services/notifications';

export function useGetNotifications() {
  const {
    fetchData,
    state: { data: reponse, error, loading },
  } = useFetch<Notification[]>();

  const fetch = ({ params, onSuccess, onError }: UseGetNotificationsProps) =>
    fetchData({
      fetcher: () => getNotificationsRequest(params),
      onError: (err) => {
        errorNotification({
          title: 'Erro ao buscar notificações.',
          message: 'tente novamente.',
        });
        onError && onError(err);
      },
      onSuccess,
    });

  return {
    fetch,
    reponse,
    error,
    loading,
  };
}

export function useSetNotificationsReaded() {
  const {
    fetchData,
    state: { data: reponse, error, loading },
  } = useFetch<void>();

  const fetch = ({ data, onSuccess }: UseSetNotificationsReadedProps) =>
    fetchData({
      fetcher: () => readNotificationsRequest(data),
      onError: () => {
        errorNotification({
          title: 'Erro ao ler notificações.',
          message: 'tente novamente.',
        });
      },
      onSuccess,
    });

  return {
    fetch,
    reponse,
    error,
    loading,
  };
}

export function useReadAllNotifications() {
  const {
    fetchData,
    state: { data: reponse, error, loading },
  } = useFetch<void>();

  const fetch = ({ onSuccess }: UseReadAllNotificationsProps) =>
    fetchData({
      fetcher: () => readAllNotificationsRequest(),
      onError: () => {
        errorNotification({
          title: 'Erro ao limpar notificações.',
          message: 'tente novamente.',
        });
      },
      onSuccess,
    });

  return {
    fetch,
    reponse,
    error,
    loading,
  };
}
